import React, { useState } from 'react'
import TextField from '@material-ui/core/TextField'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import Card from '@material-ui/core/Card'
import CardActions from '@material-ui/core/CardActions'
import CardContent from '@material-ui/core/CardContent'
import Typography from '@material-ui/core/Typography'

import { useMutation } from '@apollo/client'
import { MU_HEX_COLOR } from 'graphql/mutations'
import styles from '../hexColors.module.scss'

const HexColorEdit = ({ open, setOpen, color, update, loading }) => {
  const [name, setName] = useState(color.name)
  const [hex, setHex] = useState(color.hex)

  const [call] = useMutation(MU_HEX_COLOR)

  const onSubmit = () => {
    let variables = { id: color.id }
    if (name !== color.name) {
      variables.name = name
    }
    if (hex !== color.hex) {
      variables.hex = hex
    }
    loading(true)
    setOpen(false)
    call({
      variables,
    })
      .then(res => {
        update()
      })
      .catch(err => console.error(err))
  }

  return (
    <Dialog open={open} onClose={() => setOpen(false)} maxWidth="sm" fullWidth>
      <Card
      //   className={classes.root}
      >
        <CardContent>
          <Typography
            // className={classes.title}
            color="textSecondary"
            gutterBottom
          >
            Confirmation Dialog
          </Typography>
          <TextField
            autoFocus
            margin="dense"
            id="name"
            label="Color Name"
            type="text"
            value={name}
            onChange={e => setName(e.target.value)}
            fullWidth
          />
          <TextField
            autoFocus
            margin="dense"
            id="hex"
            label="HexCode"
            type="text"
            fullWidth
            value={hex}
            onChange={e => setHex(e.target.value)}
          />
        </CardContent>
        <CardActions>
          <Button
            variant="contained"
            onClick={() => onSubmit()}
            className={styles.submit}
            color="primary"
            disabled={name === color.name && hex === color.hex}
          >
            Submit
          </Button>
        </CardActions>
      </Card>
    </Dialog>
  )
}

export default HexColorEdit
